<div class="dialog-container">
  <iframe
    [src]="data.url | safeUrl"
    frameborder="0"
  ></iframe>
</div>